module.exports = __webpack_public_path__ + "a5431ee01a08726ff8072a4e6e94562f.png";